import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
if (typeof document !== 'undefined') {
  const head = document.head;
  ['https://cdn.magicpatterns.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'].forEach(href => {
    const l = document.createElement('link');
    l.rel = 'preconnect';
    l.href = href;
    l.crossOrigin = 'anonymous';
    head.insertBefore(l, head.firstChild);
  });
  // 2. Preload hero image
  const p = document.createElement('link');
  p.rel = 'preload';
  p.as = 'image';
  p.href = 'https://cdn.magicpatterns.com/uploads/dM5UFAffnNvMXZNE2KbFmm/Coleccion_MEGAPACK__transforma_tu_mundo_interior_(1).jpg';
  head.appendChild(p);
  // 3. Google Fonts — non-blocking
  const f = document.createElement('link');
  f.rel = 'stylesheet';
  f.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600&family=Poppins:wght@700;800&display=swap';
  f.media = 'print';
  f.onload = function () {
    ;
    (this as HTMLLinkElement).media = 'all';
  };
  head.appendChild(f);
  // 4. Meta Pixel — deferred
  if (!document.querySelector('[data-meta-pixel]')) {
    const load = () => {
      const s = document.createElement('script');
      s.setAttribute('data-meta-pixel', 'true');
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','913999121630210');fbq('track','PageView');`;
      document.head.appendChild(s);
    };
    typeof requestIdleCallback !== 'undefined' ? requestIdleCallback(load) : setTimeout(load, 4000);
  }
}
render(<App data-id="element-306" />, document.getElementById('root'));